// Small "Last updated" line for content/guide pages. A visible freshness signal
// for readers and search engines. Bump CONTENT_UPDATED when you revise content.
// Optional `date` prop overrides the site-wide default for a specific page.
export const CONTENT_UPDATED = '2026-08-14'

const fmt = (iso) => {
  try {
    // Parse as local date (avoid UTC off-by-one) and show "Month YYYY".
    const [y, m, d] = iso.split('-').map(Number)
    return new Date(y, m - 1, d).toLocaleDateString(undefined, { year: 'numeric', month: 'long' })
  } catch {
    return iso
  }
}

export default function LastUpdated({ date = CONTENT_UPDATED }) {
  return (
    <p className="last-updated">
      Last updated <time dateTime={date}>{fmt(date)}</time>
    </p>
  )
}
